const REQUEST_FEATURES_AVAILABILITY = 'platfi-ui-app/MEMBERSHIP/FEATURES_AVAILABILITY';

export { REQUEST_FEATURES_AVAILABILITY };
